import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import animationReducer from "./slices/animationSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    animation: animationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["auth/setUser"],
        // Ignore these field paths in all actions
        ignoredActionPaths: ["payload.user"],
        // Ignore these paths in the state
        ignoredPaths: ["auth.user"],
      },
    }),
});
